module.exports = __webpack_public_path__ + "img/logoWhite@2x.a0886aeb.png";